import React from "react";
import { DeletedParticipantContainer } from "../../../containers";

const DeletedParticipant = (props) => {
  return <DeletedParticipantContainer {...props} />;
};

export default DeletedParticipant;
